module.exports = __webpack_public_path__ + "img/Jump Casting35.7f1b92c5.jpg";